<template>
    <div class="edit-content video-content">
        <div class="video-edit-top">
            <ul class="video-edit-tab">
                <li class="tab-label js-tab-label f-inlineblock-top">
                    <label class="ico ico-choose f-inlineblock-middle" :class="{'ico-choose-pre': isLocalVideo}" @click="videoTypeChange('localVideo')">
                        <input class="g-input" type="radio" name="video-radio"  value="" checked="checked" >
                    </label>
                    <p class="tab-label-con f-inlineblock-top">本地视频</p>
                </li>
                <li class="tab-label js-tab-label f-inlineblock-top" v-if="showVid" checked="checked">
                    <label class="ico ico-choose f-inlineblock-middle" :class="{'ico-choose-pre': !isLocalVideo}" @click="videoTypeChange('vid')">
                        <input class="g-input" type="radio" name="video-radio"  value="" checked="checked">
                    </label>
                    <p class="tab-label-con f-inlineblock-top">VID地址</p>
                </li>
            </ul>
			<video-upload-ugc-order 
				ref="uploaderVideo"
				v-show="isLocalVideo"
				@delVideo="delVideo"
				@completed="videoCompleted"
				@videoTime="getVideoTime"
			>
				<!-- :video-id.sync="params.video_id"
				:vid.sync="params.vid"
				:title.sync="params.title"
				:video-name="params.videoName"
				:duration.sync="params.duration" -->
			</video-upload-ugc-order>
            <div class="vid-address video-edit-con" v-show="!isLocalVideo">
                <p class="vid-address-name f-inlineblock-top">VID地址</p>
                <input class="vid-address-input g-input f-inlineblock-top" type="text"
                       v-model="params.vid"
                       placeholder="输入VID,可将视频发送更多平台">
                <div class="g-bottom-btn f-inlineblock-top">
                    <a class="g-btn js-pull-btn" href="javascript:;" @click="getVidInfo" :class="{'loading-gray': !params.vid}">拉取</a>
                </div>
            </div>
        </div>

        <!-- 视频内容可编辑区域[[ -->
        <div class="video-text-content">
			<div class="abstract edit-text">
                <input type="text" style="background: transparent;" class="title-textarea" rows="1" maxlength="30" placeholder="视频时长" v-model.number="params.duration" :disabled="videoDisable">
                <span class="wordsNum"><em class="wordsNum-dynamic">秒</em></span>
            </div>
            <div class="title">
                <input type="text" class="title-textarea" rows="1" maxlength="30" placeholder="请输入标题内容（30个字以内）" v-model="params.title">
                <span class="wordsNum"><em class="wordsNum-dynamic">{{params.title.length | 0}}</em>/<em class="wordsNum-fixed">30</em></span>
                <!-- 错误提示 -->
                <p class="error-prompt" v-if="!params.title.length">未输入标题</p>
            </div>
            <!-- 与图文内容一致 -->
        </div>
        <!-- 视频内容可编辑区域]] -->
    </div>
</template>

<style  lang="scss" scoped>
    @import  '~Assets/sass/pages/v4/order/contribution.scss';
    @import  '~Assets/sass/pages/v4/order/order.scss';
    @import '~Assets/sass/pages/v4/order/order_contribute.scss';
    .loading-gray{
        filter: grayscale(100%);
    }
</style>
<script>
import videoUploadUgcOrder from 'Components/v4/upload/videoUploadUgcOrder';
import plupload from 'Assets/vendor/plupload/js/plupload.full.min.js';
import {
    UploadUrl, GetVidInfo, ReviewVideoUrl2
} from 'Services/getData.js';
export default {
    name: 'video_create.vue',
    props: ['curGameId', 'videoId', 'vid', 'title', 'summary', 'duration', 'videoName'],
    data() {
        return {
            videoId: '',
            params: {
                video_id: '', // 内容标签，
                vid: '', // n0020yrnly7
                title: '',
                duration: ''
            },
            vidInfo: {},
            isLocalVideo: true,

            uploadStatus: 1, //1上传前，2上传中，3上传后
            waitTime: '',
            fileSize: '',
            uploadedFileSize: '',
            videoUploader: {
                total: {
                    percent: 0
                }
            },
            fileName: '',
            speed: '',
            uploader2: '',
            nowFile: '',
            localSrc: '',
            videoUrl: '',
            videoUrlHttp: '',

            ruleCheck: true,
            showRulePop: false,
            showErrorPop: false,
            loading: false,
            interval: '',
            showVid: false,
            errTime: 0,
            videoDisable: true
        }
    },
    components: {
        videoUploadUgcOrder
    },
    watch: {
        "params.title": {
	            handler(curVal, oldVal){
		            this.$emit('update:title', this.params.title);
	            },
	            deep: true
        },
        "params.vid": {
	            handler(curVal, oldVal){
		            this.$emit('update:vid', this.params.vid);
	            },
	            deep: true
        },
        "params.video_id": {
	            handler(curVal, oldVal){
		            this.$emit('update:videoId', this.params.video_id);
	            },
	            deep: true
        },
        "params.duration": {
	            handler(curVal, oldVal){
		            this.$emit('update:duration', this.params.duration);
	            },
	            deep: true
        },
	        duration: {
		        handler(curVal, oldVal){
			        this.params.duration = curVal;
		        },
		        deep: true
	        },
        vidInfo: {
	            handler(curVal, oldVal){
		            this.$emit('updateVidInfo', curVal);
	            },
	            deep: true
        },
	        videoId: {
		        handler: function(val, oldVal) {
                this.params.video_id = val;
                // if(this.videoName){
                // this.$refs.uploaderVideo.fileName = this.videoName;
                // }
		        },
		        deep: true
	        },
	        title: {
		        handler: function(curVal, oldVal) {
                this.params.title = curVal;
		        },
		        deep: true
	        },
	        vid: {
		        handler: function(curVal, oldVal) {
			        if(this.vid){
				        this.params.vid = this.vid;
				        this.switchUpload();
				        //this.getVqqVidInfo();
			        }
		        },
		        deep: true
	        }
    },
    mounted() {
        	this.videoUrlHttp = ReviewVideoUrl2;
    },
    methods: {
        getVideoTime(time){
            if(!time){
                this.videoDisable = false;
            }else{
                this.videoDisable = true;
            }
            this.params.duration = time;
        },
        delVideo(){
            this.$emit('delVideo');
        },
        videoCompleted(result){
            this.params.video_id = result.videoId;
            this.$emit('completed', result);
        },
        resetParam(){
            this.params={
                video_id: '', vid: '', title: ''
            }
        },
        videoTypeChange(type) {
	            this.switchUpload(type);
	            this.$emit('videoTypeChange', this.params);
        },
        switchUpload(type= 'vid'){
            if(type == 'vid'){
                this.params.video_id = '';
                this.isLocalVideo = false;
            }else{
                this.isLocalVideo = true;
                this.params.vid = '';
                this.uploadStatus = 1;
            }
        },
        getVidInfo() {
	            if(this.params.vid.length==0){
		            // this.$alert('请填写视频vid');
		            return false;
	            }
	            this.getVqqVidInfo();
        },
        async getVqqVidInfo(){
            let res = await GetVidInfo({
                vid: this.params.vid
            });
            if(res.status === 200 && res.data.code == 0){
                if(res.data.code==0){
                    this.$message({
                        showClose: true,
                        message: '视频拉取成功~'
                    });
                    this.vidInfo = res.data.data;
                    if (this.vidInfo.title) {
                        this.params.title = this.vidInfo.title
                    }

                    if (this.vidInfo.duration) {
                        this.params.duration = this.vidInfo.duration
                    }
                }
            }
        },
        uploadError (uploader) {
            if(++this.errTime >= 2){
                this.$alert('上传源视频失败，可使用VID上传，或可重试源视频上传');
                this.showVid = true;
            }
            uploader.total.bytesPerSec = 0;
            uploader.total.statusTips = '上传失败';
            uploader.total.waitTime = '--';
            return uploader;
        }
    }
}
</script>

<style scoped>

</style>
